import React, { useState, useEffect } from 'react'
import './ServiceDetailsPage.scss'
import { LeftArrowIcon } from '../../styles/icons/svg';
import ActionButtonsBlock from './ActionButtonsBlock';
import moment from 'moment';

const ServiceDetailsPage = (props) => {

    const { vehicleData, serviceTaskId, closeServiceDetails } = props;
    const { vehicleNo, vehicleOemName, vehicleModelName } = vehicleData;
    const [serviceData, setServiceData] = useState(false);

    useEffect(() => {

        //console.log("show service details");
        const container = document.getElementsByClassName('notification-result-container')[0];
        container.classList.add('notification-result-container2');
        container.classList.remove('notification-result-container');

        const serviceObj = vehicleData.services.filter((data) => {
            // eslint-disable-next-line eqeqeq
            return data.serviceTaskId == serviceTaskId;
        })[0];

        setServiceData(serviceObj);

        return () => {
            //console.log("hide service details");
            container.classList.add('notification-result-container');
            container.classList.remove('notification-result-container2');
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [serviceTaskId]);

    const serviceRow = (heading, value, className = "") => {
        return (
            <>
                {heading !== 'Service' ?
                    <div className="service-row">
                        <div className="service-col1">{heading}</div>
                        <div className="service-col2">:</div>
                        <div className={`service-col3 ${className}`}>
                            {value}
                        </div>
                    </div> :
                    <div className="service-row-two">
                        <div className="service-col1">{heading}</div>
                        <div className="service-col2">:</div>
                        <div className={`service-column ${className}`}>
                            {value}
                        </div>
                    </div>
                }
            </>
        )
    }

    const showServiceDetails = () => {

        const { taskTitle, dueDate, lastServiceDate, serviceFee, prevSupervisor, prevMechanic, serviceDuration } = serviceData;

        let dueOnDate = moment(dueDate, 'DD-MMMM-YYYY').format("YYYYMMDD");
        let curDate = moment().format("YYYYMMDD");
        let dtExpired = dueOnDate < curDate ? 'color-red text-bold' : 'color-black';

        return (
            <div className="service-details">
                {serviceRow('Service', taskTitle, 'color-blue text-bold')}
                {serviceRow('Due Date', dueDate, dtExpired)}
                {serviceRow('Service Duration', serviceDuration, 'color-black')}
                {serviceRow('Service Fee', serviceFee, 'color-black')}
                {serviceRow('Prev Service Date', lastServiceDate, 'color-black')}
                {serviceRow('Prev. Supervisor', prevSupervisor, 'color-black')}
                {serviceRow('Prev. Mechanic', prevMechanic, 'color-black')}
            </div>
        )
    }

    return (
        <div className="service-details-container">
            <div className="service-details-header">
                <span className="service-details-back" onClick={() => closeServiceDetails()}>
                    <LeftArrowIcon />
                </span>
                <span className="service-details-heading">
                    Service Details
                </span>
            </div>
            <div className="service-details-contain">
                <div className="service-details-card">
                    <div className="card-header">
                        <div>Vehicle No. - {vehicleNo}</div>
                    </div>
                    <div className="card-body">
                        <div className="card-contain-row">
                            <div className="card-contain-col1">Vehicle OEM</div>
                            <div className="card-contain-col2">:</div>
                            <div className="card-contain-col3">{vehicleOemName}</div>
                        </div>
                        <div className="card-contain-row">
                            <div className="card-contain-col1">Vehicle Model</div>
                            <div className="card-contain-col2">:</div>
                            <div className="card-contain-col3">{vehicleModelName}</div>
                        </div>
                        {showServiceDetails(serviceData)}
                    </div>
                    <div className="card-footer">
                        <ActionButtonsBlock />
                    </div>
                </div>
            </div>
        </div >
    )
}

export default ServiceDetailsPage